import { Fragment } from 'react';

export const EditOrderContainer = Fragment;
